export const findJobsProductType = 'Find Jobs'
export const postJobsProductType = 'Post Jobs'
